import React from 'react'
import styled from 'styled-components'
import cn from 'classnames'

import Text from '../../ui/Text'

export const SToggleButton = styled.button`
    display: flex;
    align-items: center;
    gap: 3px;
    background: none;
    border: none;
    flex-wrap: wrap;
    padding: 0px;
`

export const SToggleIcon = styled.div<{ isOn: boolean }>`
    font-size: 21px;
    color: ${({ isOn, theme }) => (isOn ? theme.font.successColor : theme.font.errorColor)};
`

export const SToggleText = styled.div<{ isOn: boolean }>`
    line-height: 1;
    font-weight: var(--font-weight-bold);
    color: ${({ theme }) => theme.font.midDarkColor};
    text-transform: uppercase;
    margin-top: 4px;
`

export type ToggleButtonProps = {
    isOn: boolean
    onClick: () => void
    title?: string
    isReadOnly: boolean
    testid?: string
    hideText?: boolean
}

export function ToggleButton({
    isOn,
    onClick,
    title,
    isReadOnly,
    testid,
    hideText,
}: ToggleButtonProps): React.ReactElement {
    return (
        <SToggleButton title={title} onClick={onClick} disabled={isReadOnly} data-testid={`toggle-${testid}`}>
            <SToggleIcon
                className={cn('fa', isOn ? 'fa-toggle-on' : 'fa-toggle-off')}
                isOn={isOn}
                data-testid={`toggleIcon-${testid}`}
            />
            {!hideText && (
                <SToggleText isOn={isOn} data-testid={`toggleText-${testid}`}>
                    <Text code={isOn ? 'btnOn' : 'btnOff'} />
                </SToggleText>
            )}
        </SToggleButton>
    )
}
